import { BarChart3 } from "lucide-react";
import type { Student } from "@/lib/student.schema";
import HighSchoolScores from "./high-school-scores";

interface StudentScoresProps {
	student: Student;
}

export default function TTBoGDScores({ student }: StudentScoresProps) {
	return (
		<div className="lg:col-span-3 print:col-span-3 space-y-3">
			<div className="space-y-2">
				<div className="flex items-center gap-2 mb-2">
					<BarChart3 className="h-5 w-5 text-orange-600" />
					<span className="font-semibold text-lg text-orange-800">{student.dien_trung_tuyen}</span>
				</div>

				{student.dien_trung_tuyen === "UTX_BoGD" && <HighSchoolScores student={student} />}

				<div className="text-center p-2 bg-yellow-50 rounded-lg border">
					<div className="text-xl font-bold text-yellow-600">
						{student.giai_thuong || "Không có"}
					</div>
				</div>
			</div>
		</div>
	);
}
